/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import ModelEditContext from "components/model-selector/context";

const DialogBottomActions = () => {
    const { t } = useTranslation();
    const ctx = useContext(ModelEditContext);
    const handleClose = ctx?.handleClose;
    const selectedModel = ctx?.selectedModel;
    const onSelectModel = ctx?.onSelectModel;

    const cancelDisabled = false;
    const handleSelect = () => {
        onSelectModel(selectedModel);
    };
    return (
        <div className="simplicity-image-selector-window-footer">
            <Button variant='outlined' color='secondary' onClick={handleClose} disabled={cancelDisabled}>
                {t("commons.cancel")}
            </Button>
            <Button variant='contained' color='primary' onClick={handleSelect}>
                {t("commons.select")}
            </Button>
        </div>
    );
};

export default DialogBottomActions;
